import Icon from 'veui/components/Icon'
import { IconStarSolid } from 'dls-icons-vue'

Icon.register('star-solid', IconStarSolid)
